import type { BoardProps } from "../shared-sortaballs/Board"

import { PALETTE } from "./palette"
import { Board as SharedBoard } from "../shared-sortaballs/Board"

type GameBoardProps = Omit<BoardProps, "cssPrefix" | "palette">

export function Board(input: GameBoardProps) {
  // "bs" = legacy "ball sort" naming (see also use-ball-sort.ts). Sortaballs
  // containers are plates; normalize to a plate/use-ball-game naming in a
  // follow-up pass.
  return <SharedBoard {...input} cssPrefix="bs" palette={PALETTE} />
}
